module.exports = __webpack_public_path__ + "videos/79d1ff4c24801ab2acf7ff2ee0a9c123.mp4";